(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["live/hide-player-blur"] = factory();
	else
		root["live/hide-player-blur"] = factory();
})(globalThis, () => {
return 